module.exports = __webpack_public_path__ + "img/icon-mail.37bc5fde.png";